(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tb-currency-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const panel = document.querySelector('[data-tb-market]');
      if (!panel || panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const form = panel.querySelector('form');
      const select = form.querySelector('[name="country_code"]');
      const key = 'tb-country-choice-v1';
      const store = (value) => { try { localStorage.setItem(key, value); } catch (_) {} };
      form.addEventListener('submit', () => store(select.value));
      document.addEventListener('click', (event) => {
        if (!panel.contains(event.target)) panel.open = false;
      });
      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          panel.open = false;
          panel.querySelector('summary').focus();
        }
      });
      if (panel.dataset.designMode === 'true') return;
      let choice;
      try { choice = localStorage.getItem(key); } catch (_) { return; }
      if (choice) return;
      const usd = Array.from(select.options).find((option) => option.value === 'US');
      if (!usd) return;
      if (panel.dataset.currentCurrency === 'USD') { store('US'); return; }
      try {
        if (sessionStorage.getItem('tb-usd-attempt-v1')) return;
        sessionStorage.setItem('tb-usd-attempt-v1', '1');
        localStorage.setItem(key, 'US');
      } catch (_) { return; }
      select.value = 'US';
      form.requestSubmit();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
